export enum FeedbackStatusEnum {
  New = "New",
  WaitingForSupplier = "WaitingForSupplier",
  WaitingForAdmin = "WaitingForAdmin",
  Closed = "Closed",
  Canceled = "Canceled",
}

export const ActiveFeedbacksStatusSet = new Set<FeedbackStatusEnum>([
  FeedbackStatusEnum.New,
  FeedbackStatusEnum.WaitingForAdmin,
  FeedbackStatusEnum.WaitingForSupplier,
]);
